import React, {Component} from "react";
import {Grid} from "semantic-ui-react";
import PropTypes from "prop-types";

function Header() { return null }
function Footer() { return null }

class Repeater extends Component {

    static Header = Header;
    static Footer = Footer;

    render() {
        const {children} = this.props;
        let header, footer;
        if(children.find) {
            header = children.find(child => child.type === Header);
            footer = children.find(child => child.type === Footer);
        }
        else
        {
            header = children.type === Header ? children : null;
            footer = children.type === Footer ? children : null;
        }

        return (
            <Grid padded stackable columns='equal'>
                {!!header &&
                <Grid.Row>
                    <Grid.Column>
                        {header.props.children}
                    </Grid.Column>
                </Grid.Row>}
                <Grid.Row>
                    <Grid.Column>
                        <Grid className="repeater-body">
                            {this.props.data.map((x,index) =>
                                <Grid.Row key={index} className='repeater-row'>
                                    <Grid.Column>
                                        {React.createElement(this.props.component, { ...x, onElementInteraction: this.props.onElementInteraction })}
                                    </Grid.Column>
                                </Grid.Row>
                            )}
                        </Grid>
                    </Grid.Column>
                </Grid.Row>
                {!!footer &&
                <Grid.Row>
                    <Grid.Column>
                        {footer.props.children}
                    </Grid.Column>
                </Grid.Row>}
            </Grid>
        );
    }
}

Repeater.propTypes = {
    data: PropTypes.array.isRequired,
    component: PropTypes.elementType.isRequired,
    onElementInteraction: PropTypes.func
};

export default Repeater
